import api from '../../../services/api';

const BASE = '/blogs';

/**
 * Public blog API calls — for use in customer-facing pages
 */
export const getPublishedBlogs = (params = {}) =>
  api.get(BASE, { params });

export const getBlogBySlug = (slug) =>
  api.get(`${BASE}/${slug}`);
